import { boolean } from "mathjs";
import { atom, atomFamily, selectorFamily, selector } from "recoil";
import { math } from "@/utils/math";

// 主拆分金额
export const splitMainMoneyFamily = atomFamily<
  { orderId: string; money: number },
  string
>({
  key: "splitMainMoney",
  default: null,
});

export const OrderStore = atom<Order>({
  key: "splitMainMoney",
  default: null,
});

/**
 * 拆分订单列表
 */
export const splitMoneyFamily = atomFamily<Array<SplitMoney>, string>({
  key: "splitMoney",
  default: [],
});

// 合并订单列表
export const mergeOrderListStore = atom<Array<Order>>({
  key: "mergeOrderList",
  default: [],
});

// 选中的合并订单列表
export const mergeOrderSelectIdsStore = atom<Array<string>>({
  key: "mergeOrderSelectIds",
  default: [],
});

/**
 * 定购信息
 */
export const buyJournalStore = atom<{
  // 各版本定购数量（key 为版本类型 1：黑白版 2：彩色版）
  numbers: Record<number, number>;
  // 各版本含税单价（key 为版本类型）
  prices: Record<number, number>;
  checked: boolean;
  receive: {
    address: string;
    contact: string;
    phone: string;
  };
}>({
  key: "buyJournalStore",
  default: {
    numbers: {},
    prices: {},
    checked: false,
    receive: {
      address: "",
      contact: "",
      phone: "",
    },
  },
});

/**
 * 定购总金额派生状态（Σ 版本单价 × 数量）
 */
export const buyJournalMoneySelector = selector<number>({
  key: "buyJournalMoneySelector",
  get: ({ get }) => {
    const buyJournal = get(buyJournalStore);
    if (!buyJournal.checked) return 0;
    return Object.entries(buyJournal.numbers).reduce((total, [type, num]) => {
      const price = buyJournal.prices[Number(type)] || 0;
      return Number(
        math
          .add(
            math.bignumber(total),
            math.multiply(math.bignumber(price), math.bignumber(num || 0)),
          )
          .toString(),
      );
    }, 0);
  },
});

/**
 * 是否开启
 */
export const isBuyJournalSelector = selector<boolean>({
  key: "isBuyJournalSelector",
  get: ({ get }) => {
    const buyJournal = get(buyJournalStore);
    return buyJournal.checked;
  },
});

/**
 * POD 发票信息
 */
export const podBillStore = atom<(InvoiceInfo & InvoiceAddress) | null>({
  key: "podBillStore",
  default: null,
});
